import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React, { CSSProperties } from "react";

export function PublishIcon(props: SvgIconProps) {
  const st0: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 1.0637,
    strokeMiterlimit: 10,
  };
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g>
        <g>
          <path
            style={st0}
            d="M13.87,1.94c-0.16-0.42-0.47-0.45-0.71-0.07L0.77,21.92c-0.24,0.38-0.08,0.57,0.34,0.41l21.98-8.07
			c0.42-0.15,0.45-0.46,0.06-0.69l-5.61-3.22c-0.39-0.22-0.83-0.75-0.99-1.17L13.87,1.94z"
          />
        </g>
        <line style={st0} x1="16.59" y1="10.13" x2="1.66" y2="21.6" />
      </g>
    </SvgIcon>
  );
}
